import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteClasses } from "@/http/classesApi";
import { getAppointmentsQueryKey, getSlotsQueryKey } from "@/utils/queryKeys";

interface DeleteClassesData {
  usertoken: string;
  appointment_id: string;
}

export const useDeleteClassesMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: DeleteClassesData) => {
      const response = await deleteClasses(data.usertoken, data.appointment_id);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getAppointmentsQueryKey() });
      queryClient.invalidateQueries({ queryKey: getSlotsQueryKey() });
    },
  });
};
